import React from 'react';
import { appRoutes } from '../../../routes/routes';
import { subscribeToSageHRStatus } from '../../../services/sagehr';
import { IntegrationTile } from './IntegrationTile.component';

export const SageHRTile = () => (
  <IntegrationTile
    name="Sage HR"
    description="Push Prodaff tracked hours to Sage HR as timesheet entries."
    logoText="SHR"
    logoColor="#00b188"
    route={appRoutes().integrationsSageHR}
    subscribeToStatus={subscribeToSageHRStatus}
  />
);
